export const APP_CONFIG = {
	domain: 'trainapp.pl',
	apiUrl: 'https://trainapp.pl/api/',
	wsUrl: 'wss://trainapp.pl',
	baseHref: '/main',
}